import { api } from '@/api'

interface ClientGroupConfigMap {
  banner_show?: string
  login_mode?: string
  [key: string]: any
}

interface ClientGroupConfigResponse {
  clientGroupConfigMap: ClientGroupConfigMap
  clientGroupId: number
  clientGroupName: string
}

export interface AppConfig {
  login: string[]
  showBanner: boolean
}

export async function fetchAppConfig() {
  try {
    const { data } = await api.get<ClientGroupConfigResponse>('/client/group/getClientGroupConfig')

    const configMap = data.clientGroupConfigMap || {}
    const loginModes = configMap.login_mode
      ? configMap.login_mode.split(',').map((mode: string) => mode.trim()).filter(Boolean)
      : []
    const showBanner = configMap.banner_show === '1'

    const appConfig: AppConfig = { login: loginModes, showBanner }
    localStorage.setItem('AppConfig', JSON.stringify(appConfig))
  }
  catch (error) {
    console.error('Failed to fetch app config:', error)
    const defaultConfig: AppConfig = { login: [], showBanner: false }
    localStorage.setItem('AppConfig', JSON.stringify(defaultConfig))
  }
}

export function getAppConfig(): AppConfig | null {
  try {
    const raw = localStorage.getItem('AppConfig')
    return raw ? JSON.parse(raw) : null
  }
  catch {
    return null
  }
}
